import * as homeConstants from 'home/constants'
import { combineReducers } from 'redux'
import { emptyArray } from 'utils'

import {
  FETCH_RANKING_HOURLY_COUNTRIES,
  FETCH_RANKING_HOURLY_COUNTRIES_ERROR,
  FETCH_RANKING_HOURLY_COUNTRIES_SUCCESS,
  FETCH_RANKING_HOURLY_STORES,
  FETCH_RANKING_HOURLY_STORES_ERROR,
  FETCH_RANKING_HOURLY_STORES_SUCCESS,
  FETCH_RANKINGS_COUNTRIES,
  FETCH_RANKINGS_COUNTRIES_ERROR,
  FETCH_RANKINGS_COUNTRIES_SUCCESS,
  HIDE_FILTER_COUNTRY_MODAL,
  INDICATORS,
  OPEN_FILTER_COUNTRY_MODAL,
  ORDER,
  RANKINGS,
  SET_FILTER_COUNTRY_INPUT,
  SET_INDICATOR,
  SET_RANKING,
  SET_SELECTED_COUNTRIES,
  SET_SELECTED_COUNTRY,
  SET_SELECTED_COUNTRY_COMPARED,
  SET_SELECTED_STORE,
  SET_SELECTED_STORE_COMPARED,
  SET_SORT,
  SORT,
  TOGGLE_ARE_FILTERS_EXPANDED,
  TOGGLE_COLLAPSED,
  TOGGLE_WEEKLY,
} from './constants'

const areFiltersExpanded = (state = false, { type }) => {
  switch (type) {
    case TOGGLE_ARE_FILTERS_EXPANDED:
      return !state
    default:
      return state
  }
}

const countries = (state = emptyArray, { payload, type }) => {
  switch (type) {
    case FETCH_RANKINGS_COUNTRIES_SUCCESS:
      return payload
    case FETCH_RANKINGS_COUNTRIES_ERROR:
      return emptyArray
    default:
      return state
  }
}

const filterCountryInput = (state = '', { payload, type }) => {
  switch (type) {
    case SET_FILTER_COUNTRY_INPUT:
      return payload
    default:
      return state
  }
}

const initialIndicatorState = INDICATORS.REVENUE_CURRENT
const indicator = (state = initialIndicatorState, { payload, type }) => {
  switch (type) {
    case SET_INDICATOR:
      return payload
    case SET_RANKING: {
      if (payload === RANKINGS.HOURS_REVENUE) {
        return INDICATORS.COMPANIES_NECOMMERCE
      }

      if (payload === RANKINGS.CLUB_CARD) {
        return INDICATORS.REVENUE_CLUB_CURRENT
      }

      return initialIndicatorState
    }
    default:
      return state
  }
}

const isFetchError = (state = false, { type }) => {
  switch (type) {
    case SET_SELECTED_COUNTRY:
    case SET_SELECTED_COUNTRY_COMPARED:
    case FETCH_RANKINGS_COUNTRIES_SUCCESS:
      return false
    case FETCH_RANKINGS_COUNTRIES_ERROR:
      return true
    default:
      return state
  }
}

const isFilterCountryModalOpen = (state = false, { type }) => {
  switch (type) {
    case OPEN_FILTER_COUNTRY_MODAL:
      return true
    case HIDE_FILTER_COUNTRY_MODAL:
      return false
    default:
      return state
  }
}

const isWeekly = (state = true, { type }) => {
  switch (type) {
    case TOGGLE_WEEKLY:
      return !state
    default:
      return state
  }
}

const isFetching = (state = false, { dateCurrent, type }) => {
  switch (type) {
    case homeConstants.FETCH_COUNTRIES:
      return dateCurrent ? state : true
    case FETCH_RANKING_HOURLY_COUNTRIES:
    case FETCH_RANKINGS_COUNTRIES:
    case FETCH_RANKING_HOURLY_STORES:
    case SET_SELECTED_COUNTRY:
    case SET_SELECTED_COUNTRY_COMPARED:
    case SET_SELECTED_COUNTRIES:
      return true
    case FETCH_RANKINGS_COUNTRIES_SUCCESS:
    case FETCH_RANKINGS_COUNTRIES_ERROR:
    case FETCH_RANKING_HOURLY_COUNTRIES_ERROR:
    case FETCH_RANKING_HOURLY_COUNTRIES_SUCCESS:
    case FETCH_RANKING_HOURLY_STORES_SUCCESS:
    case FETCH_RANKING_HOURLY_STORES_ERROR:
    case homeConstants.FETCH_COUNTRIES_SUCCESS:
      return false
    default:
      return state
  }
}

const ranking = (state = RANKINGS.COMPANIES_STATIONARY, { payload, type }) => {
  switch (type) {
    case SET_RANKING:
      return payload
    default:
      return state
  }
}

const selectedCountries = (state = emptyArray, { payload, type }) => {
  switch (type) {
    case SET_SELECTED_COUNTRIES:
      return payload
    default:
      return state
  }
}

const isCollapsed = (state = true, { type }) => {
  switch (type) {
    case SET_RANKING:
      return true
    case TOGGLE_COLLAPSED:
      return !state
    default:
      return state
  }
}

const dataPerHour = (state = emptyArray, { payload, type }) => {
  switch (type) {
    case SET_RANKING:
    case FETCH_RANKING_HOURLY_COUNTRIES:
    case FETCH_RANKING_HOURLY_COUNTRIES_ERROR:
    case FETCH_RANKING_HOURLY_STORES:
    case FETCH_RANKING_HOURLY_STORES_ERROR:
      return emptyArray
    case FETCH_RANKING_HOURLY_COUNTRIES_SUCCESS:
    case FETCH_RANKING_HOURLY_STORES_SUCCESS:
      return payload
    default:
      return state
  }
}

const selectedCountry = (state = null, { payload, type }) => {
  switch (type) {
    case SET_SELECTED_STORE:
      return payload ? payload.countryId : null
    case SET_SELECTED_COUNTRY:
      return payload
    default:
      return state
  }
}

const selectedCountryCompared = (state = null, { payload, type }) => {
  switch (type) {
    case SET_SELECTED_STORE_COMPARED:
      return payload ? payload.countryId : null
    case SET_SELECTED_COUNTRY_COMPARED:
      return payload
    default:
      return state
  }
}

const selectedStore = (state = null, { payload, type }) => {
  switch (type) {
    case SET_SELECTED_STORE:
      return payload ? payload.storeId : null
    case SET_INDICATOR:
      return null
    default:
      return state
  }
}

const selectedStoreCompared = (state = null, { payload, type }) => {
  switch (type) {
    case SET_SELECTED_STORE_COMPARED:
      return payload ? payload.storeId : null
    default:
      return state
  }
}

const initialSortState = { sortBy: SORT.INDICATOR, order: ORDER.DESC }
const sort = (state = initialSortState, { payload, type }) => {
  switch (type) {
    case SET_SORT:
      if (payload === state.sortBy) {
        return {
          order: state.order === ORDER.DESC ? ORDER.ASC : ORDER.DESC,
          sortBy: payload,
        }
      }

      return {
        order: ORDER.DESC,
        sortBy: payload,
      }
    case SET_RANKING:
      return payload === RANKINGS.WORST_20_SHOPS ? { sortBy: SORT.INDICATOR, order: ORDER.ASC } : initialSortState
    default:
      return state
  }
}

export default combineReducers({
  areFiltersExpanded,
  countries,
  dataPerHour,
  filterCountryInput,
  indicator,
  isCollapsed,
  isFetchError,
  isFetching,
  isFilterCountryModalOpen,
  isWeekly,
  ranking,
  selectedCountries,
  selectedCountry,
  selectedCountryCompared,
  selectedStore,
  selectedStoreCompared,
  sort,
})
